import { AxiosBookings, AxiosMULEEX, orgId, userId } from "../apiConfig";

import { appendQueryParams } from "../../utilities/urlUtils";

export const locationsApiFactory = {
  $_getAllLocations() {
    let url = `/location/get-all-location/${orgId()}`;
    return AxiosMULEEX.get(url);
  },
  $_getLocationsManaged() {
    let url = `/location-user/${userId()}`;
    return AxiosMULEEX.get(url);
  },
  $_getTakeOffLocations() {
    let url = "/locations?type=takeoff";
    return AxiosBookings.get(url);
  },
  $_getDeliveryLocations() {
    let url = `/locations?userId=${userId()}&type=delivery`;
    return AxiosBookings.get(url);
  },
  $_getRecieverLocations(params) {
    let url = `/locations${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_deleteLocation(locationId) {
    const url = `/locations/${locationId}`;
    return AxiosBookings.delete(url);
  },
  $_updateLocation(locationId, payload) {
    delete payload.id;
    const url = `/locations/${locationId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_setDefaultLocation(locationId, payload) {
    const url = `/locations/setdefault/${locationId}`;
    // const userId = localStorage.getItem("userId");
    // const payload = {
    //   userId: userId,
    // };
    return AxiosBookings.patch(url, payload);
  },
  $_getAllBookingLocations(params) {
    let url = `/locations${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_newGetAllBookingLocations(){
    let url = `/location/view-location/all/without-orgId`
    return AxiosMULEEX.get(url);
  },
  $_getDefaultLocation(){
    let url = `/locations/default-location/${userId()}`
    return AxiosBookings.get(url);
  }
};
